// :cow: Cosmose CONFIDENTIAL :iso:
import { Action } from '@ngrx/store';
import { ReportMetricsType } from '@med/app/home/campaign/modules/report/model/report-metrics-type';
import { CampaignStatsReportTypeEnum } from '@med/app/home/campaign/model/campaign-stats-report-type.enum';
import { DateRange } from '@med/app/home/campaign/modules/report/model/date-range';

export const REPORT_SET_METRICS_TYPE = '[REPORT] Set metrics type';
export const REPORT_SET_REPORT_TYPE = '[REPORT] Set report type';
export const REPORT_SET_REPORT_TYPES = '[REPORT] Set report types';
export const REPORT_SET_DATE_RANGE = '[REPORT] Set date range';
export const REPORT_SET_AUDIENCE_SEGMENT = '[REPORT] Set audience segments';
export const REPORT_RESET = '[REPORT] Reset';

export class ReportReset implements Action {
  readonly type = REPORT_RESET;
}

export class SetMetricsType implements Action {
  readonly type = REPORT_SET_METRICS_TYPE;

  constructor(public payload: { type: ReportMetricsType }) {
  }
}

export class SetReportType implements Action {
  readonly type = REPORT_SET_REPORT_TYPE;

  constructor(public payload: { type: CampaignStatsReportTypeEnum }) {
  }
}

export class SetReportMetricsTypes implements Action {
  readonly type = REPORT_SET_REPORT_TYPES;

  constructor(public payload: { types: ReportMetricsType[] }) {
  }
}

export class SetReportDateRange implements Action {
  readonly type = REPORT_SET_DATE_RANGE;

  constructor(public payload: DateRange) {
  }
}

export class SetAudienceSegment implements Action {
  readonly type = REPORT_SET_AUDIENCE_SEGMENT;

  constructor(public payload: { segment: string }) {
  }
}

export type All = SetMetricsType | SetReportType | SetReportMetricsTypes | SetReportDateRange | ReportReset | SetAudienceSegment;
